// extracted by mini-css-extract-plugin
module.exports = {"base":"Group-module-base","shadow":"Group-module-shadow"};